import { useCallback } from 'react';
import onEnterDown from './onEnterDown';
import onTabDown from './onTabDown';
import onBackspaceDown from './onBackspaceDown';
export const useOnKeyDown = (editor) => {
    const onKeyDown = useCallback((e) => {
        if (e.nativeEvent.isComposing) {
            // Do not override IME's key handling
            return;
        }
        if (e.key === 'Enter') {
            onEnterDown(e, editor);
        }
        else if (e.key === 'Tab') {
            onTabDown(e, editor);
        }
        else if (e.key === 'Backspace') {
            onBackspaceDown(e, editor);
        }
    }, [editor]);
    return onKeyDown;
};
//# sourceMappingURL=index.js.map